export default {
	SOLUTION: 0,
	SUBMISSION: 1,
}
